export const brand = {

  colors: {
    navy: '#092395',

    darkNavy: '#071a2f',

    blue: '#0993b5',

    green: '#1fa97a',

    light: '#f0f2f5',

    white: '#ffffff',

    gray: '#667085'
  },

  name: 'VITA',

  tagline: 'Territorial Intelligence'

};